import {
    ConsentLevel,
    createRegisterableComponent,
} from '@news-mono/web-common'
import React from 'react'
import { PuzzleIframe } from '../../content/PuzzleIframe/PuzzleIframe'
import { ThemeMargins } from '../../__styling/settings/metrics'

export interface PuzzleIframeRouteProps {
    link: string
    marginBottom?: keyof ThemeMargins
    sandbox?: string
    name?: string
    consentRequiredLevel?: ConsentLevel
}

export const PuzzleIframeRegistration = createRegisterableComponent(
    'puzzleIframe',
    (props: PuzzleIframeRouteProps, services) => (
        <PuzzleIframe key={`iframe${services.location.pathname}`} {...props} />
    ),
)
